import React, { useRef, useState, useEffect } from "react"
import PropTypes from "prop-types"
import * as styles from "./AccordionItem-tw-styles"
import Link from "../../../../UI/Link/Link"
import Button from "../../../../UI/Button/Button"
import { gaMenuClick } from "../../../../../constants/gtm.constants"

const AccordionItem = ({
  item,
  active,
  clicked,
  setClicked,
  index,
  setActive,
  onToggle,
}) => {
  const contentEl = useRef()
  const [hasInnerChild, setHasInnerChild] = useState(false)
  const [toggleId, setToggleId] = useState([])
  const style = styles["defaultStyle"]

  const [refHeight, setRefHeight] = useState()
  const [hasSecondInnerChild, setHasSecondInnerChild] = useState(false)
  const [secondToggleId, setSecondToggleId] = useState([])
  const refOne = useRef()

  const getListHeightRef = () => {
    const refHeight = refOne?.current?.scrollHeight
    setRefHeight(refHeight)
  }

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter") {
      if (toggleId.includes(index)) {
        if (!hasInnerChild) {
          setToggleId([...toggleId, index])
        }
        let toggleIdCopy = [...toggleId]
        let closeIndex = toggleIdCopy.indexOf(index)
        toggleIdCopy.splice(closeIndex, 1)
        setToggleId(toggleIdCopy)
        setHasInnerChild(!hasInnerChild)
      } else {
        setToggleId([...toggleId, index])
        setHasInnerChild(true)
      }
    }
  }

  const handleKeyDown2 = (event, index) => {
    if (event.key === "Enter") {
      if (secondToggleId.includes(index)) {
        if (!hasSecondInnerChild) {
          setSecondToggleId([...secondToggleId, index])
        }
        let secondToggleIdCopy = [...secondToggleId]
        let closeIndex = secondToggleIdCopy.indexOf(index)
        secondToggleIdCopy.splice(closeIndex, 1)
        setSecondToggleId(secondToggleIdCopy)

        setHasSecondInnerChild(!hasSecondInnerChild)
      } else {
        setSecondToggleId([...secondToggleId, index])
        setHasSecondInnerChild(true)
      }
    }
  }

  useEffect(() => {
    const handler = event => {
      if (
        active &&
        clicked === index &&
        contentEl.current &&
        !contentEl.current.contains(event.target)
      ) {
        setClicked("")
        setActive(false)
      }
    }
    document.addEventListener("mousedown", handler)
    document.addEventListener("touchstart", handler)
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler)
      document.removeEventListener("touchstart", handler)
    }
  }, [active, clicked, index])

  const handleInnerAccordion = index => {
    if (toggleId.includes(index)) {
      if (!hasInnerChild) {
        setToggleId([...toggleId, index])
      }
      let toggleIdCopy = [...toggleId]
      let closeIndex = toggleIdCopy.indexOf(index)
      toggleIdCopy.splice(closeIndex, 1)
      setToggleId(toggleIdCopy)
      setHasInnerChild(!hasInnerChild)
    } else {
      setToggleId([...toggleId, index])
      setHasInnerChild(true)
    }
  }

  const handleSecondInnerAccordion = index => {
    if (secondToggleId.includes(index)) {
      if (!hasSecondInnerChild) {
        setSecondToggleId([...secondToggleId, index])
      }
      let secondToggleIdCopy = [...secondToggleId]
      let closeIndex = secondToggleIdCopy.indexOf(index)
      secondToggleIdCopy.splice(closeIndex, 1)
      setSecondToggleId(secondToggleIdCopy)

      setHasSecondInnerChild(!hasSecondInnerChild)
    } else {
      setSecondToggleId([...secondToggleId, index])
      setHasSecondInnerChild(true)
    }
  }

  useEffect(() => {
    getListHeightRef()
  }, [toggleId])

  return (
    <li
      className={
        active && clicked === index
          ? `${style?.TopNavWrapIN} ToggleOpened`
          : style?.TopNavWrapIN
      }
    >
      {item?.link ? (
        <Link {...item?.link} className={style?.TopNavLink} gaEventClass={gaMenuClick}
        gaEventLabel={item?.label}>
          {item.label}
        </Link>
      ) : (
        <Button
          className={style?.TopNavBtn}
          onClick={onToggle}
          data-testid={item.label}
          ariaExpanded={active && clicked === index ? true : false}
          ariaControls={item.label}
        >
          {item.label}
          <span className={active ? "accordianIcon active" : "accordianIcon"}>
            {" "}
          </span>
        </Button>
      )}

      <div id={item.label} ref={contentEl} className={style?.TopNavMegaWrap} aria-label={item.label + " Tab"}>
        {/* First Level Accordion*/}
        {item?.dropdownItems?.map((item, index1) => {
          if (item?.dropdownItems?.length > 0) {
            return (
              <div key={index1} className="megListToatlParent">
                <div
                  onClick={() => handleInnerAccordion(index1)}
                  onKeyDown={event => handleKeyDown(event, index1)}
                  className={
                    toggleId.includes(index1)
                      ? "megListParent active "
                      : "megListParent "
                  }
                  tabIndex={0}
                  data-testid = {`inneraccordionitem-${index1}`}
                  aria-label={item.label}
                >
                  {item.label}
                  <span
                    className={
                      toggleId.includes(index1)
                        ? "accordianIconSub active "
                        : "accordianIconSub "
                    }
                  ></span>
                </div>

                <div
                  className={
                    toggleId.includes(index1)
                      ? "megListParentMain activeToSub"
                      : "megListParentMain"
                  }
                >
                  <div
                    className={`megListParentsup${index1} megListParent2`}
                    ref={refOne}
                  >
                    {/* Second Level Accordion */}
                    {item?.dropdownItems?.map((item, index2) => {
                      if (item?.dropdownItems?.length > 0) {
                        return (
                          <div key={index2}>
                            <div
                              className={
                                secondToggleId.includes(index2)
                                  ? "megListParent3 active"
                                  : "megListParent3"
                              }
                              onClick={() => handleSecondInnerAccordion(index2)}
                              onKeyDown={event => handleKeyDown2(event, index2)}
                              data-testid = {`innersecondaccordionitem-${index1}`}
                              tabIndex={0}
                              aria-label={item.label}
                            >
                              {item.label}{" "}
                              <span
                                className={
                                  secondToggleId.includes(index2)
                                    ? "accordianIconSub active"
                                    : "accordianIconSub"
                                }
                              ></span>
                            </div>
                            <div
                              className={
                                secondToggleId.includes(index2)
                                  ? "seccondToggleTop active"
                                  : "seccondToggleTop"
                              }
                            >
                              <div>
                                {item?.dropdownItems?.map((item, index3) => {
                                  return (
                                    <Link
                                      {...item?.link}
                                      key={index3}
                                      tabIndex={
                                        secondToggleId.includes(index2)
                                          ? "0"
                                          : "-1"
                                      } gaEventClass={gaMenuClick}
                                      gaEventLabel={item?.label}
                                    >
                                      {item?.label}
                                    </Link>
                                  )
                                })}
                              </div>
                            </div>
                          </div>
                        )
                      }
                      return (
                        <div key={index2}>
                          <Link
                            {...item?.link}
                            tabIndex={toggleId.includes(index1) ? "0" : "-1"} gaEventClass={gaMenuClick}
                            gaEventLabel={item?.label}
                          >
                            {item.label}
                          </Link>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            )
          } else {
            return (
              <div key={index1}>
                <Link {...item?.link} gaEventClass={gaMenuClick}
                      gaEventLabel={item?.label}>{item.label}</Link>
              </div>
            )
          }
        })}
      </div>
    </li>
  )
}

AccordionItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.bool,
  clicked: PropTypes.any,
  setClicked: PropTypes.func,
  index: PropTypes.number,
  setActive: PropTypes.func,
  onToggle: PropTypes.func,
}

export default AccordionItem
